<div class="modal-content-flex">
    <div class="modal-header">
        <h4 class="modal-title drop-modal-title" id="modal-basic-title" tabindex="-1" ngbAutofocus>{{getTotalItems()}}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal(false)"></button>
    </div>
    <div class="modal-body">
        <div *ngIf="isLoading" class="progress-bar-wrapper">
            <div class="step" [class.active]="true">
                <span class="step-number">{{progressStep}}</span>
                <span class="step-label">{{progressText}}</span>
            </div>
            <div class="progress">
                <div class="progress-bar" role="progressbar" [style.width]="(progressStep/numberOfLoadingSteps*100)+'%'" aria-valuenow="progressStep" aria-valuemin="0" aria-valuemax="3"></div>
            </div>
        </div>
        <div class="checkout-items" *ngIf="initialized && !isLoading">
            <ng-container *ngFor="let item of getDueTodayItems()">
                <div class="checkout-item">
                    <div class="row">
                        <div class="col-3">
                            <div class="item-image pack" *ngIf="purchasePreviewData?.ImageUrl == ''">
                                <div class="quantity">
                                    {{item.Quantity}}
                                </div>
                                <div class="unit">
                                    {{item.Unit}}
                                </div>
                            </div>
                            <div class="item-image subscription" [style.background-image]="'url(' + purchasePreviewData?.ImageUrl +')'" *ngIf="purchasePreviewData?.ImageUrl != ''"></div>
                        </div>
                        <div class="col-9">
                            <div class="item-details">
                                <h4 class="title">
                                    {{item.Name}} <span class="prorated" *ngIf="isProrated(item)"> - Prorated </span>
                                    <span class="tag" *ngIf="hasDiscountLabel(item)">
                                        {{getDiscountLabel(item)}}
                                    </span>
                                </h4>
                                <p class="renews-on" *ngIf="item.IsSubscription">
                                    Renews on {{getNextDueOnDateStr(item)}}
                                </p>
                                <p class="renews-on" *ngIf="!item.IsSubscription">
                                    One-Time Charge
                                </p>
                                <p class="price" *ngIf="!item.IsSubscription">
                                    <span class="actual-price" *ngIf="item.AmountInfo.ChargableBreakup.SubTotal">${{item.AmountInfo.ChargableBreakup.SubTotal/100}}</span>
                                </p>
                                <p class="price" *ngIf="item.IsSubscription">
                                    <span *ngIf="isProrated(item)" class="actual-price">${{item.AmountInfo.ChargableBreakup.SubTotal/100}} (${{item.AmountInfo.FullCycleBreakup.AmountBeforeProcessingFee/100}} <span class="term">&nbsp;{{getTermDuration(item)}}</span>)</span>
                                    <span *ngIf="!isProrated(item)" class="actual-price">${{item.AmountInfo.FullCycleBreakup.SubTotal/100}}</span> <span *ngIf="!isProrated(item)" class="term">&nbsp;{{getTermDuration(item)}}</span>
                                </p>
                                <!-- <a href="javascript:void(0)" class="remove-item" (click)="removeItem(item.Id)">remove</a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="upcoming-payments" *ngIf="getUpcomingPaymentItemsCount() > 0">
                <h5 class="title">UPCOMING PAYMENTS</h5>
                <ng-container *ngFor="let item of getUpcomingPaymentItems()">
                <div class="content upcoming-payment-item">
                    <div class="row faded">
                        <div class="col-9">
                            <p class="title">{{item.Name}}</p>
                            <p class="description" *ngIf="item.Description">{{item.Description}}</p>
                            <p class="description">Due on {{getDueOnDateStr(item)}}</p>
                        </div>
                        <div class="col-3">
                            <p class="title">{{getFormattedPrice(item.AmountInfo.FullCycleBreakup.SubTotal - item.AmountInfo.FullCycleBreakup.DiscountAmount) | currency}}</p>
                            <p class="description" *ngIf="item.IsSubscription" class="numeric">{{getFormattedPrice((item.AmountInfo.FullCycleBreakup.SubTotal - item.AmountInfo.FullCycleBreakup.DiscountAmount)) | currency}} {{getTermDurationShort(item)}}</p>
                        </div>
                    </div>
                </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="total-wrapper" *ngIf="initialized && !isLoading">
            <div class="agreement-acceptance" *ngIf="(purchasePreviewData?.Agreements?.length ?? 0) > 0">
                <div>
                    <input id="termsOfServiceConsentCheckbox" name="termsOfServiceConsentCheckbox" type="checkbox" class="Checkbox-Input" [checked]="isAgreeToTerms" (change)="onAgreementAcceptanceChange($event)" />
                    I acknowledge and consent to this 
                    <ul>
                        <li *ngFor="let doc of purchasePreviewData.Agreements; let i = index">
                            <a href="javascript:void(0)" (click)="openDocumentPreview(doc)">{{doc.Name}}</a><span *ngIf="i < purchasePreviewData.Agreements.length - 1">, </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="content p-t-0" *ngIf="paymentMethods.length > 0">
                <div class="row">
                    <div class="col-4">Payment Method</div>
                    <div class="col-8">
                        <div class="pm-dropdown" [class.open]="isPmDropdownOpen">
                            <button type="button" class="pm-selected" (click)="togglePmDropdown($event)">
                                <img class="pm-icon" [src]="getPaymentMethodIcon(getSelectedPaymentMethod())" alt="pm" />
                                <span class="pm-label">{{ getPaymentMethodLabel(getSelectedPaymentMethod()) }}</span>
                                <span class="pm-badge" *ngIf="isDefaultPaymentMethod(getSelectedPaymentMethod())">Default</span>
                                <span class="pm-caret">▼</span>
                            </button>
                            <div class="pm-menu" *ngIf="isPmDropdownOpen">
                                <div class="pm-item add-new" (click)="openAddPaymentMethodPopup()">
                                    + Add payment method
                                </div>
                                <div class="pm-divider"></div>
                                <div class="pm-list-scroll" (wheel)="$event.stopPropagation()">
                                    <div class="pm-item" *ngFor="let paymentMethod of paymentMethods" (click)="selectPaymentMethod(paymentMethod, $event)" [class.default]="isDefaultPaymentMethod(paymentMethod)" [class.active]="selectedPaymentMethodId && (getPaymentMethodId(paymentMethod) === selectedPaymentMethodId)">
                                        <img class="pm-icon" [src]="getPaymentMethodIcon(paymentMethod)" alt="pm" />
                                        <span class="pm-label">{{ getPaymentMethodLabel(paymentMethod) }}</span>
                                        <span class="pm-badge" *ngIf="isDefaultPaymentMethod(paymentMethod)">Default</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content" *ngIf="paymentMethods.length == 0">
                <div class="row">
                    <div class="col-6">Payment Method</div>
                    <div class="col-6">
                        <a href="javascript:void(0)" class="add-card-btn" (click)="openAddPaymentMethodPopup()">Add payment method</a>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="row faded">
                    <div class="col-6">Subtotal</div>
                    <div class="col-6">
                        <p class="numeric">${{getFormattedPrice(purchasePreviewData?.GrandAmountInfo?.ChargableBreakup?.SubTotal ?? 0)}}</p>
                    </div>
                </div>
            </div>
            <div class="content" *ngIf="(purchasePreviewData?.GrandAmountInfo?.ChargableBreakup?.DiscountAmount ?? 0) > 0">
                <div class="row faded">
                    <div class="col-6">Discount</div>
                    <div class="col-6">
                        <p class="numeric">- ${{getFormattedPrice(purchasePreviewData?.GrandAmountInfo?.ChargableBreakup?.DiscountAmount ?? 0)}}</p>
                    </div>
                </div>
            </div>
            <div class="content" *ngIf="(purchasePreviewData?.GrandAmountInfo?.ChargableBreakup?.AdditionalDiscountAmount ?? 0) > 0">
                <div class="row faded">
                    <div class="col-6">Additional Discount</div>
                    <div class="col-6">
                        <p class="numeric">- ${{getFormattedPrice(purchasePreviewData?.GrandAmountInfo?.ChargableBreakup?.AdditionalDiscountAmount ?? 0)}}</p>
                    </div>
                </div>
            </div>
            <div class="content"  *ngIf="(purchasePreviewData?.GrandAmountInfo?.ChargableBreakup?.TaxAmount ?? 0) > 0">
                <div class="row faded">
                    <div class="col-6">Sales Tax</div>
                    <div class="col-6">
                        <p class="numeric">+ ${{getFormattedPrice(purchasePreviewData?.GrandAmountInfo?.ChargableBreakup?.TaxAmount ?? 0)}}</p>
                    </div>
                </div>
            </div>
            <div class="content" *ngIf="(purchasePreviewData?.GrandAmountInfo?.ChargableBreakup?.ProcessingFee ?? 0) > 0">
                <div class="row faded">
                    <div class="col-6">Processing Fee ({{purchasePreviewData?.GrandAmountInfo?.ProcessingFeeRate | number:'1.2-2'}}%)</div>
                    <div class="col-6">
                        <p class="numeric">+ ${{getFormattedPrice(purchasePreviewData?.GrandAmountInfo?.ChargableBreakup?.ProcessingFee ?? 0)}}</p>
                    </div>
                </div>
            </div>
            <div class="content"  *ngIf="(purchasePreviewData?.GrandAmountInfo?.ChargableBreakup?.StoreCreditsUsed ?? 0) > 0">
                <div class="row faded">
                    <div class="col-6">Store Credits</div>
                    <div class="col-6">
                        <p class="numeric">- ${{getFormattedPrice(purchasePreviewData?.GrandAmountInfo?.ChargableBreakup?.StoreCreditsUsed ?? 0)}}</p>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="row">
                    <div class="col-6">Total (Due Today)</div>
                    <div class="col-6">
                        <p class="numeric">${{getFormattedPrice(purchasePreviewData?.GrandAmountInfo?.ChargableBreakup?.NetAmount ?? 0)}}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <button type="button" class="btn btn-dark checkout-button" [disabled]="submitted || paymentMethods.length == 0 || ((purchasePreviewData?.Agreements?.length ?? 0) > 0 && !isAgreeToTerms)" (click)="checkout()">
                        <div *ngIf="submitted" class="spinner-border" role="status">
                            <span class="visually-hidden">Checking Out...</span>
                            </div>
                            <span *ngIf="!submitted">CHECKOUT</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<df-login #login title="Confirm your purchase" (loggedIn)="loggedIn($event)"></df-login>